const es = {
  'home.eyebrow':         '🌍 geoplay24.com',
  'home.title':           'Geo Play 24',
  'home.subtitle.line1':  '7 juegos de geografía inmersivos.',
  'home.subtitle.line2':  '1 mundo. 5 niveles. Asombro infinito.',
  'home.tagline.line1':   'Siete juegos, un planeta.',
  'home.tagline.line2':   'Descubre cada rincón de la Tierra — compite, gana puntos, conquista tu imperio.',
  'home.footer.company':  'Empresa',
  'home.footer.legal':    'Legal',
  'home.footer.about':    'Sobre nosotros',
  'home.footer.contact':  'Contacto',
  'home.footer.github':   'GitHub',
  'home.footer.tiktok':   'TikTok',
  'home.footer.x':        'X / Twitter',
  'home.footer.privacy':  'Privacidad',
  'home.footer.terms':    'Términos',
  'home.footer.cookies':  'Cookies',
  'home.copy':            'powered by: © 2026 Janek @ DevFlow C ™️',
  'home.beta.title':      'Únete a los primeros testers de nuestra app Android',
  'home.beta.text':       'Consigue una insignia Founder, Premium de por vida y una oportunidad en los premios sorteados arriba.',
  'home.beta.cta':        'Programa BETA',

  'common.start':         'Empezar',
  'common.startBig':      '▶ Empezar',
  'common.back':          'Atrás',
  'common.home':          'Inicio',
  'common.howToPlay':     'Cómo jugar',
  'common.gotIt':         'Entendido — volver al juego',
  'common.next':          'Siguiente',
  'common.restart':       'Reiniciar',
  'common.tryAgain':      'Intentar de nuevo',
  'common.playAgain':     'Jugar de nuevo',
  'common.mainMenu':      'Menú principal',
  'common.quit':          'Salir',
  'common.play':          'Jugar',
  'common.unlock':        '🔒 Desbloquear con Premium',
  'common.language':      'Idioma',

  'rules.kicker.goal':         'Objetivo',
  'rules.kicker.howToPlay':    'Cómo jugar',
  'rules.kicker.levels':       'Niveles',
  'rules.kicker.tips':         'Consejos',
  'rules.gameNotFound':        'Juego no encontrado',
  'rules.points':              'pts',

  'games.origin.title':       'Origin Hunt',
  'games.origin.tagline':     'Encuentra tus raíces',
  'games.origin.description': 'Una ubicación aleatoria de Street View en algún lugar del mundo. Marca el punto en el mapa. Precisión 100 km → 1 km en 5 niveles.',
  'games.hunt.title':         'Object Hunt',
  'games.hunt.tagline':       'Caza del tesoro estilo GPS',
  'games.hunt.description':   'Te dejan cerca de un monumento real. Camina por Street View para encontrarlo. La brújula se vuelve menos útil cada nivel.',
  'games.photo.title':        'Photo Detective',
  'games.photo.tagline':      'Lee las pistas',
  'games.photo.description':  'Una sola foto Street View — sin paneo, sin movimiento. Lee carteles, plantas, dirección del sol. De 30 seg a un destello de 5 seg.',
  'games.pangaea.title':      'Pangaea Puzzle',
  'games.pangaea.tagline':    'Reensambla la Tierra',
  'games.pangaea.description':'Continentes e islas flotando alrededor de un globo 3D. Devuélvelos a su sitio — posición actual o la antigua Pangea.',

  'rules.origin.goal': 'Te dejan en un Street View aleatorio en la Tierra. Sitúate en el mapa mundial con la mayor precisión posible.',
  'rules.origin.step1': 'Mira el panorama. Lee carteles, cuenta carriles, observa la dirección del sol.',
  'rules.origin.step2': 'Haz clic en el minimapa para colocar un pin.',
  'rules.origin.step3': 'Envía. Cuanto más cerca esté tu pin del sitio real, más puntos.',
  'rules.origin.step4': 'Niveles encadenados — supera el umbral de distancia para desbloquear el siguiente.',
  'rules.origin.level1': 'a 100 km',
  'rules.origin.level2': 'a 50 km',
  'rules.origin.level3': 'a 25 km',
  'rules.origin.level4': 'a 10 km',
  'rules.origin.level5': 'a 1 km',
  'rules.origin.tip1': 'Sentido de circulación, formato de matrículas y color de las marcas viales delatan el país rápido.',
  'rules.origin.tip2': 'Vegetación + altura del sol acotan la latitud. Las señales de calle fijan la ciudad.',
  'rules.origin.tip3': 'Master Geographer (N5 = 1 km) es brutal — la mayoría de partidas terminan en N3 o N4.',

  'rules.hunt.goal': 'Te colocan en Street View cerca de un monumento real. Camina por el panorama hasta estar encima. La brújula ayuda menos cada nivel.',
  'rules.hunt.step1': 'Lee el nombre del objetivo en la barra superior.',
  'rules.hunt.step2': 'Usa la flecha de la brújula + distancia para orientarte.',
  'rules.hunt.step3': 'Haz clic en las flechas para caminar por Street View.',
  'rules.hunt.step4': 'Dentro de la zona de búsqueda, el botón "¡Lo encontré!" se activa — púlsalo para puntuar.',
  'rules.hunt.level1': '5 km · 10 min · mundialmente famoso · flecha + distancia exacta · zona 100 m',
  'rules.hunt.level2': '15 km · 12 min · mundialmente famoso · flecha + distancia redondeada',
  'rules.hunt.level3': '25 km · 12 min · conocido nacionalmente · solo brújula, sin distancia',
  'rules.hunt.level4': '50 km · 15 min · conocido nacionalmente · pista frío/caliente',
  'rules.hunt.level5': '50 km · 10 min · oscuro · solo el nombre del POI, sin GPS',
  'rules.hunt.tip1': 'En N4–N5 tienes 3 Compass Pings — destellos de flecha, úsalos con tino.',
  'rules.hunt.tip2': 'Bono de medio camino: pasar la mitad da +2 minutos.',
  'rules.hunt.tip3': 'Si solo tienes el nombre, busca en tu memoria o mira los alrededores — muchos hitos se reconocen desde lejos.',

  'rules.photo.goal': 'Ves una sola imagen estática de Street View — sin paneo ni movimiento. Por carteles, plantas, sol y marcas viales deduces el lugar.',
  'rules.photo.step1': 'Elige primero una región (Mundo, Europa, Asia…) — define el pajar.',
  'rules.photo.step2': 'La foto aparece durante un tiempo fijo. Aprovecha cada segundo.',
  'rules.photo.step3': 'Tras el temporizador aparece un mapa. Coloca tu mejor pin.',
  'rules.photo.step4': 'Más cerca = más puntos. La pantalla de resultados te enseña la foto otra vez.',
  'rules.photo.level1': '30 seg observación · precisión 1 000 km',
  'rules.photo.level2': '20 seg · 500 km',
  'rules.photo.level3': '15 seg · 250 km',
  'rules.photo.level4': '10 seg · 100 km',
  'rules.photo.level5': 'destello 5 seg · 50 km',
  'rules.photo.tip1': 'El idioma de los carteles es la pista más rápida. Una sola palabra suele bastar.',
  'rules.photo.tip2': 'La dirección del sol indica el sur (hemisferio norte) o el norte (hemisferio sur).',
  'rules.photo.tip3': 'Forma de los postes, marcas viales y matrículas son sorprendentemente reveladores.',

  'rules.pangaea.goal': 'Una Tierra 3D, seis continentes. Coloca cada uno dentro de la tolerancia angular del nivel — posición actual o donde estaban hace 300 millones de años en Pangea.',
  'rules.pangaea.step1': 'Elige un continente en la lista de la derecha.',
  'rules.pangaea.step2': 'Haz clic en el globo donde crees que va.',
  'rules.pangaea.step3': 'Dentro de la tolerancia → se ajusta solo. Si no → señal roja, otra vez.',
  'rules.pangaea.step4': '3 intentos por continente. Coloca al menos 5 de 6 para avanzar.',
  'rules.pangaea.level1': 'Continentes · hoy · tolerancia 25°',
  'rules.pangaea.level2': 'hoy · tolerancia 18°',
  'rules.pangaea.level3': 'hoy · 12° preciso',
  'rules.pangaea.level4': 'Pangea · antiguo · tolerancia 25°',
  'rules.pangaea.level5': 'Pangea · antiguo · 18° preciso',
  'rules.pangaea.tip1': 'Arrastra el globo para girar. Rueda para hacer zoom.',
  'rules.pangaea.tip2': 'En Pangea los continentes estaban agrupados en el sur — África y Sudamérica encajaban, India pegaba al este de África, Norteamérica abrazaba a Europa.',
  'rules.pangaea.tip3': 'La Antártida estaba cerca del ecuador. Australia se aferraba por abajo.',

  /* ─── Landmark Quiz ─── */
  'games.landmark.title':          'Landmark Quiz',
  'games.landmark.tagline':        'Reconoce el monumento',
  'games.landmark.description':    'Una foto de un edificio o monumento famoso — reconócelo y marca su ubicación en el mapa mundial.',
  'rules.landmark.goal':           'Ves la foto de un monumento famoso. Coloca un pin en el mapa mundial donde crees que está.',
  'rules.landmark.step1':          'Mira la foto unos segundos. Reconoce el edificio, observa el contexto.',
  'rules.landmark.step2':          'Cuando termina el temporizador, aparece el mapa.',
  'rules.landmark.step3':          'Coloca un pin y envía. Más cerca = más puntos.',
  'rules.landmark.step4':          'Cinco niveles. Cada uno más corto y más exigente.',
  'rules.landmark.level1':         '30 seg observación · precisión 1 000 km',
  'rules.landmark.level2':         '20 seg · 500 km',
  'rules.landmark.level3':         '15 seg · 250 km',
  'rules.landmark.level4':         '10 seg · 100 km',
  'rules.landmark.level5':         'destello de 5 seg · 50 km',
  'rules.landmark.tip1':           'Formas inconfundibles (Eiffel, pirámides) se reconocen al instante — los puntos vienen de un pin preciso.',
  'rules.landmark.tip2':           'Monumentos menos famosos: lee el contexto — clima, arquitectura, entorno.',
  'rules.landmark.tip3':           'Fotos de Wikipedia con licencia CC-BY-SA. Toca el crédito para ver la fuente.',

  'paywall.title':        "Este juego es Premium",
  'paywall.text':         "Desbloquea este juego con los puntos que ganas jugando.",
  'paywall.cta':          "Únete al programa BETA",
  'paywall.dismiss':      "Quizá más tarde",

  /* ─── Spot the Landmark ─── */
  'games.spot.title':       "Spot the Landmark",
  'games.spot.tagline':     "Opción múltiple",
  'games.spot.description': "Foto de un edificio o monumento famoso — elige la respuesta correcta entre 3-6 opciones. Modo infinito, más difícil cada ronda.",

  'rules.spot.goal':   "Mira la foto, elige el monumento correcto. Una respuesta mala termina la partida.",
  'rules.spot.step1':  "Elige una región (Mundo, Europa, Asia…) — la piscina se filtra por continente.",
  'rules.spot.step2':  "Aparece una foto de monumento famoso con una pregunta.",
  'rules.spot.step3':  "Toca la respuesta correcta entre las opciones.",
  'rules.spot.step4':  "Mantén la racha — cada nivel añade una opción (máx 6) y se pone más duro.",
  'rules.spot.level1': "N1–N3 · 3–5 opciones · solo el nombre",
  'rules.spot.level2': "N4+ · 6 opciones · solo el nombre",
  'rules.spot.level3': "N10+ · 6 opciones · nombre + país",
  'rules.spot.level4': "N20+ · 6 opciones · nombre + ciudad + país",
  'rules.spot.level5': "Infinito · puntuación según profundidad · un fallo termina",
  'rules.spot.tip1':   "Los distractores vienen del mismo continente — lee con cuidado.",
  'rules.spot.tip2':   "Formas icónicas (Eiffel, pirámides) son fáciles — los puntos vienen de profundidad.",
  'rules.spot.tip3':   "En N10 se añade el país; en N20 la ciudad.",

  "spot.region.title": "¿Dónde quieres jugar?",
  "spot.region.sub": "Elige una región. Aparecerán monumentos famosos — elige la respuesta correcta.",
  "spot.q.name": "¿Qué monumento es este?",
  "spot.q.namecountry": "¿Nombre + país?",
  "spot.q.namecity": "¿Nombre + ciudad + país?",
  "spot.score": "Puntos",
  "spot.choices": "opciones",
  "spot.correct": "CORRECTO",
  "spot.wrong": "FALLO",
  "spot.points": "PUNTOS",
  "spot.runTotal": "Total partida",
  "spot.next": "Siguiente →",
  "spot.youPicked": "Elegiste",
  "spot.finalScore": "PUNTUACIÓN FINAL",
  "spot.reachedLevel": "Alcanzaste el nivel",
  "spot.tryAgain": "Reintentar ↺",
  "spot.changeRegion": "Cambiar región",
  "spot.mainMenu": "Menú principal",

  /* ─── Auth ─── */
  "auth.signIn": "Entrar",
  "auth.eyebrow": "MINDFUL ZEN WORLD",
  "auth.title": "Entrar o crear una cuenta",
  "auth.subtitle": "Sin contraseña — te enviamos un enlace mágico por email. ¿Eres nuevo? Se crea cuenta automáticamente.",
  "auth.send": "Enviar enlace",
  "auth.sending": "Enviando…",
  "auth.invalidEmail": "Introduce un email válido.",
  "auth.sendFailed": "No se pudo enviar el enlace. Inténtalo de nuevo.",
  "auth.checkInbox": "Revisa tu bandeja",
  "auth.linkSentTo": "Un enlace de acceso va camino a",
  "auth.spamHint": "¿No lo ves? Mira en la carpeta de spam. El enlace caduca en 1 hora.",
  "auth.gotIt": "Entendido",
  "auth.fineprint": "Al continuar aceptas nuestros Términos y Política de privacidad.",
  "auth.menu.profile": "Mi perfil",
  "auth.menu.admin": "Admin",
  "auth.menu.signOut": "Cerrar sesión",
  "auth.callback.signingIn": "Iniciando sesión…",
  "auth.callback.hold": "Un segundo.",
  "auth.callback.welcome": "Bienvenido",
  "auth.callback.redirecting": "Te llevamos a los juegos…",
  "auth.callback.problem": "Algo salió mal",

  /* ─── Auth ─── */

  /* ─── Profile ─── */
  "profile.title": "Mi Perfil",
  "profile.totalPoints": "Puntos totales",
  "profile.totalRuns": "Partidas jugadas",
  "profile.gamesPlayed": "Juegos probados",
  "profile.editTitle": "Editar perfil",
  "profile.displayName": "Nombre mostrado",
  "profile.avatar": "Avatar",
  "profile.country": "País (opcional)",
  "profile.countryHint": "Código ISO de 2 letras, ej. ES, US, JP. Para banderas del ranking.",
  "profile.save": "Guardar",
  "profile.saving": "Guardando…",
  "profile.saved": "Guardado",
  "profile.nameTooShort": "El nombre debe tener al menos 2 caracteres.",
  "profile.perGame": "Mejor por juego",
  "profile.noRuns": "Aún no has jugado — vuelve al menú y elige un juego.",

  /* ─── Profile ─── */

  /* ─── Gating + Anon limit ─── */
  "common.locked": "BLOQUEADO",
  "common.needPoints": "NECESITAS {n} PTS",
  "locked.pill": "BLOQUEADO",
  "locked.title": "{game} está bloqueado",
  "locked.text": "Te faltan {remaining} puntos para desbloquear {game}. Sigue jugando los juegos disponibles.",
  "locked.dismiss": "Entendido",
  "spot.anon.playsLeft": "Te quedan {n} partidas gratis — inicia sesión para seguir.",
  "spot.anon.title": "Has usado tus partidas gratis",
  "spot.anon.text": "Has jugado {used} de {limit} partidas gratis. Inicia sesión para seguir — gratis, sin contraseña, solo un enlace mágico por email.",
  "spot.anon.signIn": "Iniciar sesión →",
  "spot.anon.back": "Volver al menú",

  /* ─── Gating + Anon limit ─── */

  /* ─── Next game banner ─── */
  "rules.next.upcoming": "A CONTINUACIÓN",
  "rules.next.unlocked": "SIGUIENTE — DESBLOQUEADO",
  "rules.next.unlockedHint": "Tienes puntos suficientes — vuelve al menú y juega.",
  "rules.next.needMore": "{remaining} pts para desbloquear — sigue jugando.",
  "rules.next.signedOut": "Consigue {threshold} puntos para desbloquear — inicia sesión para contar.",
  "rules.next.premiumHint": "Desbloqueado con Premium — llega con la beta de Android.",

  /* ─── Next game banner ─── */

  /* ─── Audio Atlas ─── */
  'games.audio.title':       "Audio Atlas",
  'games.audio.tagline':     "Bandera + himno",
  'games.audio.description': "Suena un himno nacional, ves la bandera del país. Pon un pin en la capital.",

  'rules.audio.goal':   "Oyes un himno nacional y ves la bandera. Coloca un pin en la capital — lo más preciso posible.",
  'rules.audio.step1':  "Elige una región. La piscina se filtra al continente.",
  'rules.audio.step2':  "El himno empieza automáticamente. La bandera queda visible.",
  'rules.audio.step3':  "Al llegar a cero, aparece el mapa. Coloca el pin en la capital.",
  'rules.audio.step4':  "Pasar = dentro del umbral. Mayor nivel = escucha más corta.",
  'rules.audio.level1': "10 seg · ≤ 1 000 km",
  'rules.audio.level2': "8 seg · 500 km",
  'rules.audio.level3': "6 seg · 250 km",
  'rules.audio.level4': "4 seg · 100 km",
  'rules.audio.level5': "Flash 3 seg · 50 km",
  'rules.audio.tip1':   "Reconocer la bandera es lo fácil — clavar la capital es la prueba real.",
  'rules.audio.tip2':   "Algunas capitales no son la ciudad más grande (Brasília, Canberra, Ottawa, Pretoria).",
  'rules.audio.tip3':   "Tempo y instrumentos del himno ayudan si la bandera es desconocida.",

  "audio.region.title": "¿Dónde quieres escuchar?",
  "audio.region.sub": "Elige una región. Oirás un himno nacional y verás la bandera del país — pon un pin en la capital del mapa.",
  "audio.empty.title": "Aún no hay clips de audio",
  "audio.empty.text": "Aún no hay himnos disponibles — estamos preparando la selección. Vuelve pronto para identificar nuevos países.",
  "audio.listen.hint": "¿Reconoces la bandera y el himno? Pon el pin en la capital.",
  "audio.listen.skip": "Ya sé suficiente →",
  "audio.submit.ready": "Enviar →",
  "audio.submit.empty": "Haz clic en el mapa para poner un pin",
  "audio.changeRegion": "Cambiar región",

  /* ─── Empire ─── */
  "profile.empire.title": "Mi Imperio",
  "profile.empire.empty": "Identifica un país en Audio Atlas o Landmark Quiz para reclamarlo. Tu imperio crece con cada acierto.",

  /* ─── Empire ─── */

  /* ─── Boost / Shop ─── */
  "boost.title": "Sáltate el grind",
  "boost.tagline": "Compra puntos, desbloquea más rápido",
  "boost.description": "¿No quieres esperar? Tres packs desde €2.99. Los puntos llegan al instante y cuentan para cada desbloqueo.",
  "boost.cta": "Comprar puntos",
  "shop.title": "Tienda de puntos",
  "shop.sub": "Sáltate el grind",
  "shop.buy": "Comprar",
  "shop.opening": "Abriendo…",
  "shop.success": "Pago confirmado — puntos acreditados en segundos.",
  "shop.cancel": "Pago cancelado — sin cargos.",
  "shop.fineprint": "Compra única vía Stripe. Los puntos llegan tras la confirmación. Sin suscripción, sin renovación.",
  "shop.boost.badge": "Popular",
  "shop.power.badge": "Mejor valor",

  /* ─── Boost / Shop ─── */
};

export default es;
